import React from 'react';
import style from '../src/lazyloading.module.css';
import loading from '../src/assets/ico_cargando.gif';

export default function LazyLoading(){
    return(
        <div className={style.gralLazyLoading}>
            <img id={style.imgLazy} src={loading} alt="Cargando..."></img>
        </div>
    )
}